import { api, get, post } from '@/lib/api';

const patch = <T>(caminho: string, corpo: unknown) =>
  api<T>(caminho, { method: 'PATCH', body: corpo });

const del = (caminho: string) => api<unknown>(caminho, { method: 'DELETE' });

const BASE = '/okrs';

// ── tipos ────────────────────────────────────────────────────────────────────

export interface KeyResult {
  id: string;
  title: string;
  /** Decimal vem como string do JSON do Prisma */
  currentValue: string;
  targetValue: string;
  unit?: string | null;
}

export interface OKR {
  id: string;
  title: string;
  description?: string | null;
  periodStart: number;
  periodEnd: number;
  keyResults: KeyResult[];
}

// ── consultas ────────────────────────────────────────────────────────────────

export const listarOKRs = () => get<OKR[]>(BASE);

// ── mutações ─────────────────────────────────────────────────────────────────

export const criarOKR = (data: {
  title: string;
  description?: string;
  periodStart: number;
  periodEnd: number;
}) => post<OKR>(BASE, data);

export const adicionarKeyResult = (
  okrId: string,
  data: { title: string; targetValue: number; unit?: string },
) => post<KeyResult>(`${BASE}/${okrId}/key-results`, data);

export const atualizarKeyResult = (okrId: string, krId: string, currentValue: number) =>
  patch<KeyResult>(`${BASE}/${okrId}/key-results/${krId}`, { currentValue });

export const excluirOKR = (okrId: string) =>
  del(`${BASE}/${okrId}`) as Promise<{ ok: boolean }>;
